import {createButtonComponent, IButtonProperties, IButtonBusinessLogic} from '@vfde-brix/button';
import {NO_PATTERN_BUSINESS_LOGIC} from '@vfde-brix/core';

/**
 * Export mountButton
 *
 * @export mountButton
 */
export const mountButton = (target, submitButtonText, action) => {

    const buttonBusinessLogic: IButtonBusinessLogic = {
        onClick: action,
    };

    const props: IButtonProperties = {
        content: submitButtonText,
        optWidthVariation: 'auto',
        optColor: 'strong',
        optShape: 'rectangle',
        size: 'large',
        business: buttonBusinessLogic,
    };

    return createButtonComponent(target, props);

};

/**
 * Export mountResetButton
 *
 * @export mountResetButton
 */
export const mountResetButton = (target, action) => {

    const buttonBusinessLogic: IButtonBusinessLogic = {
        onClick: action,
    };

    const props: IButtonProperties = {
        content: 'Weitere Adresse pr&uuml;fen',
        optWidthVariation: 'auto',
        optColor: 'light',
        optShape: 'rectangle',
        size: 'medium',
        href: 'javascript:',
        business: buttonBusinessLogic,
    };

    return createButtonComponent(target, props);
};

/**
 * Export mountResetButton
 *
 * @export mountRedirectButton
 */
export const mountRedirectButton = (target, href, redirectText) => {

    const props: IButtonProperties = {
        content: redirectText,
        optWidthVariation: 'auto',
        optColor: 'strong',
        optShape: 'rectangle',
        size: 'medium',
        href: href,
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    return createButtonComponent(target, props);
};
